import axios from "axios";
import { API_URL } from "@/config";

const store = {
  namespaced: true,

  actions: {
    async getMany(_, criteria) {
      const response = await axios.get(`${API_URL}/mealTypes`, { params: criteria });

      if (!response.data || typeof response.data.items !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async getOne(_, mealTypeId) {
      const response = await axios.get(`${API_URL}/mealTypes/${mealTypeId}`);

      if (!response.data || typeof response.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async create(_, mealTypeData) {
      const response = await axios.post(`${API_URL}/mealTypes`, mealTypeData);

      if (response.status !== 201 || !response.data || typeof response.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async update(_, { mealTypeId, mealTypeData }) {
      const response = await axios.put(`${API_URL}/mealTypes/${mealTypeId}`, mealTypeData);

      if (response.status !== 200 || !response.data || typeof response.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async remove(_, mealTypeId) {
      const response = await axios.delete(`${API_URL}/mealTypes/${mealTypeId}`);

      if (response.status !== 200 || !response.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },

    async getGroupedByInstitutionsMealTypesInstitutionsSettings(_, { institutionId, criteria }) {
      const q = {
        institutionId: institutionId,
        ...criteria,
      };

      const res = await axios.get(`${API_URL}/mealTypeInstitutionSettings/groupedByInstitutions`, {
        params: q,
      });

      if (!res.data) {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async getMealTypesCount(_, criteria) {
      const res = await axios.get(`${API_URL}/mealTypes/count`, { params: criteria });

      if (res.status !== 200 || typeof res.data !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async markAsDefault(_, mealTypeId) {
      const response = await axios.post(`${API_URL}/mealTypes/${mealTypeId}/markAsDefault`);

      if (
        response.status !== 200 ||
        typeof response.data.id !== "number" ||
        !response.data.default
      ) {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async getDefaultMealType() {
      const response = await axios.get(`${API_URL}/mealTypes/default`);

      if (!response.data || typeof response.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async getOptions(_, criteria = {}) {
      const response = await axios.get(`${API_URL}/mealTypes/options`, { params: criteria });

      if (!response.data || typeof response.data !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },
  },
};

export default store;
